import {
  AggregateMap as GlobalAggregateMap,
  AggregateReduce as GlobalAggregateReduce,
} from './common.js';

export const MathInlineSelectionsReducer = () => [];

export const MathInlineSelectionsAggregator = () => [];

export default {
  AggregateMap: GlobalAggregateMap(MathInlineSelectionsAggregator),
  AggregateReduce: GlobalAggregateReduce(MathInlineSelectionsReducer),
};
